import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Theme } from '@radix-ui/themes'
import App from './App'
import { AuthProvider } from './auth/AuthProvider'
import { THEME_PROPS } from './theme'
import './index.css'

const queryClient = new QueryClient()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <Theme {...THEME_PROPS}>
          <App queryClient={queryClient} />
        </Theme>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>
)
